import { AppAPiUrl } from "../../configs/appData";
import {  useNavigate, useParams } from "react-router-dom";
import MaterialReactDataTable from "../../components/layout/MaterialReactDataTable";
import { Box, Button, Card, CardContent, Stack, Typography } from "@mui/material";
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import colorConfigs from "../../configs/colorConfigs";
import { useEffect, useState } from "react";
import AxiosMain from "../../components/layout/AxiosMain";


const productRow = [
    {
        accessorFn: (row) => row.name,
        header: "Applicable On",
    },
    {
        accessorFn: (row) => row.price,
        header: "Price",
    },
]

function ResellerPricelistsSingle(props){

    const navigate = useNavigate();

    const param = useParams();
    const { id } = param;

    const [priceListData, setPriceListData] = useState();

    const fetchPriceListDetails = async() =>{
        try{
            const response = await AxiosMain.get(`${AppAPiUrl.PriceListDetails}${id}/`);
            setPriceListData(response.data)
        }
        catch{
            console.log("Enable to fetch Pricelist details")
        }
    }

    useEffect(()=>{
        fetchPriceListDetails();
    },[])


    return(
        <Box sx={{ my: "20px" }}>
            <Box sx={{ marginBottom: "20px" }}>
                <Button
                    onClick={() => navigate("/admin/reseller-pricelists")}
                    variant="contained"
                    startIcon={<ArrowBackIosIcon />}
                    className="cm-btn-sm-style"
                    sx={{
                        color: colorConfigs.btnColor.hoverbgWhite,
                        background: colorConfigs.btnColor.bgColorRed,
                        "&: hover": {
                            color: colorConfigs.btnColor.bgColorRed,
                            background: colorConfigs.btnColor.hoverbgWhite,
                        }
                    }}>
                    Back
                </Button>
            </Box>
            <Box sx={{ marginBottom: "20px" }}>
                <Card>
                    <CardContent>
                        <Stack direction="row" alignItems={"center"} justifyContent={"space-between"}>
                            <Box sx={{ fontSize: "20px", color: "#012445", fontWeight: 600 }}>{priceListData?.name}</Box>
                          
                        </Stack>
                        <Box sx={{ marginTop: "20px", paddingBottom: "15px", borderBottom: "1px solid #CCCCCC" }}>
                            <Stack direction="row" alignItems={"center"} justifyContent={"space-between"}>
                                <Box sx={{ fontSize: "16px", color: "#012445", fontWeight:'fontWeightMedium'}}>Currency:</Box>
                                <Typography component={'p'}>{priceListData?.currency}</Typography>
                            </Stack>
                            <Stack direction="row" alignItems={"center"} justifyContent={"space-between"}>
                                <Box sx={{ fontSize: "16px", color: "#012445", fontWeight:'fontWeightMedium' }}>Company:</Box>
                                <Typography component={'p'}>{priceListData?.company}</Typography>
                            </Stack>
                            <Stack direction="row" alignItems={"center"} justifyContent={"space-between"}>
                                <Box sx={{ fontSize: "16px", color: "#012445", fontWeight:'fontWeightMedium' }}>Agents/Reseller:</Box>
                            </Stack>
                        </Box>
                        <Box sx={{ marginTop: "20px" }}>
                            {priceListData?.agents.length > 0 && priceListData.agents.map((item, index) => {
                                return (
                                    <Box key={`commission-counting-agents-${index}`} sx={{ marginBottom: "20px" }}>
                                        <Stack direction="row" alignItems={"center"} justifyContent={"space-between"}>
                                            <Box sx={{ fontSize: "16px", color: "#012445" }}>{item?.name}</Box>
                                        </Stack>
                                    </Box>
                                )
                            })}
                        </Box>
                    </CardContent>
                </Card>
            </Box>
                <MaterialReactDataTable
                    useFor={"Price List details"}
                    apiLink={`${AppAPiUrl.PriceListProducts}${id}/`}
                    tRow={productRow}
                    clickFuncDataShow={true}/>

    </Box>
    )
}

export default ResellerPricelistsSingle;